import IconCancel from '@bimser/icons/16/cancel';
import IconOk from '@bimser/icons/16/ok';
import { CustomizedDxColumn } from './generateColumns';

const containerStyle: React.CSSProperties = {
	display: 'inline-block'
};

const cellComponent = function (props) {
	return <div style={containerStyle}>{props.data.value ? <IconOk /> : <IconCancel />}</div>;
};

export const setCheckBox = (dxColumn: CustomizedDxColumn) => {
	dxColumn.cellComponent = cellComponent;
};
